
<component
  :is="asyncComponent"
  class="sdv-smart-block-item"
  :settings="item ? item.settings : {}"
  :context="context"
  @action="onAction"
  @call-event="onSmartblockEvent"
  @analytics="onAnalytics"
/>
